import { ApiService } from 'src/services/core';
import VwPersonel from 'src/models/GenelTanimlar/VwPersonelDTO';

class VwPersonelService extends ApiService<VwPersonel>{
    constructor() {
        super('VwPersonelDTO');
    }
}
export default new VwPersonelService();